import React from "react";
import { Route, Routes } from "react-router";
import Chats from "../containers/admin/ChatLayout";
import AllEmployee from "../containers/admin/AllEmployee";
import AddEmployee from "../containers/admin/AllEmployee/AddEmployee";
import Settings from "../containers/admin/Settings";
import PendingChatRequests from "../containers/admin/PendingChatRequests";
import ChatInfo from "../containers/admin/ChatLayout/Message/ChatInfo";
import EmployeeChat from "../containers/admin/EmployeeChat";
import ChatLayout from "../containers/admin/EmployeeChat/EmployeePage";
import EditUser from "../containers/admin/AllEmployee/EditUser";
import Task from "../containers/admin/Task";
import AdminTask from "../containers/admin/Task";
import IncomingCallModal from "../containers/admin/ChatLayout/Message/ChatHeader/IncomingCallModal";
import ActiveCallModal from "../containers/admin/ChatLayout/Message/ChatHeader/ActiveCallModal";

const adminRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/chats" element={<Chats />} />

        <Route path="/employee" element={<AllEmployee />} />
        <Route path="/employee/add-employee" element={<AddEmployee />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/pending-request" element={<PendingChatRequests />} />
        <Route path="/user-chat" element={<EmployeeChat />} />
        <Route path="/chat" element={<ChatLayout />} />
        <Route path="/employee/edit-user/:id" element={<EditUser />} />
        <Route path="/task" element={<AdminTask />} />
      </Routes>
      <IncomingCallModal />
      <ActiveCallModal />
    </div>
  );
};

export default adminRoutes;
